<template>
  <custom-callout show-edition>
    <div class="row">
      <div class="col-sm-1 d-flex align-items-center justify-content-center">
        <icon i="fas fa-map-marker-alt" />
      </div>
      <div class="col-sm">
        <span class="font-14 color-secondary-6">Tipo:</span>
        <p class="font-16 color-black">{{ data.type }}</p>
      </div>
      <div class="col-sm">
        <span class="font-14 color-secondary-6">Dirección Física:</span>
        <p class="font-16 color-black">{{ data.address }}</p>
      </div>
      <div class="col-sm d-flex justify-content-end mr-5">
        <drop-down :items="actions" />
      </div>
    </div>

    <template #edition>
      <div class="row px-3">
        <div class="col-12 mb-3 mt-2">
          <em
            class="fas fa-plus rounded-circle p-1 mr-2 color-green shadow bg-white"
          />
          <span>Añadir Dirección Postal</span>
        </div>
      </div>

      <div class="px-5">
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <custom-drop-down
              v-model="model.type"
              fieldkey="id"
              fieldname="description"
              label="Tipo:"
              :options="[]"
              placeholder="Seleccione"
            />
          </div>
        </div>
        <hr />
        <div class="row mt-3">
          <div class="col-sm">
            <custom-input
              v-model="model.address1"
              label="Dirección (Línea 1):"
            />
          </div>
          <div class="col-sm">
            <custom-drop-down
              v-model="model.municipality"
              fieldkey="id"
              fieldname="description"
              label="Municipio:"
              :options="[]"
              placeholder="Seleccione"
            />
          </div>
          <div class="col-sm">
            <custom-input v-model="model.zipcode" label="Código Postal:" />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-4 col-sm-12">
            <div class="row">
              <div class="col mb-2">
                <custom-input
                  v-model="model.address2"
                  label="Dirección (Línea 2):"
                />
              </div>
            </div>
            <div class="row">
              <div class="col">
                <custom-input
                  v-model="model.address3"
                  label="Dirección (Línea 3):"
                />
              </div>
            </div>
          </div>
          <div class="col d-flex align-items-end">
            <custom-text-area
              class="w-100"
              label="Anotaciones Adicionales:"
              placeholder="Escribir información adicional de cómo llegar…"
              rows="4"
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col d-flex justify-content-end align-items-end mb-2">
            <action-button
              class="mr-2 w-15"
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger"
            />
            <action-button class="w-15" text="Añadir" variant="success" />
          </div>
        </div>
      </div>
    </template>
  </custom-callout>
</template>

<script>
import CustomCallout from '@/components/common/CustomCallout';
import CustomInput from '@/components/common/form/CustomInput';
import CustomDropDown from '@/components/common/form/CustomDropDown';
import CustomTextArea from '@/components/common/form/CustomTextArea';
import Icon from './Icon';

export default {
  name: 'ContactInformationEdit',
  components: {
    CustomCallout,
    Icon,
    CustomInput,
    CustomDropDown,
    CustomTextArea,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      model: this.data,
      actions: [
        { label: 'Editar', icon: 'fas fa-edit color-primary-1' },
        { label: 'Eliminar', icon: 'fas fa-times-circle text-danger' },
      ],
    };
  },
};
</script>
